import React from "react";
import { View } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function Fun(props) {
  const color = props.color || "#FFFFFF";
  const width = props.width || 32;
  const height = props.height || 32;

  return (
    <View {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M16.6212 7.78258L18.3162 13.0006C18.3574 13.131 18.4388 13.245 18.5488 13.3263C18.6588 13.4076 18.7917 13.452 18.9285 13.4531H24.4216C24.5646 13.4396 24.7082 13.474 24.8296 13.5509C24.9509 13.6278 25.0433 13.743 25.0921 13.8781C25.1409 14.0133 25.1433 14.1609 25.099 14.2976C25.0548 14.4343 24.9663 14.5525 24.8475 14.6334L20.4105 17.8547C20.2983 17.9347 20.2147 18.0484 20.1716 18.1793C20.1285 18.3102 20.1282 18.4514 20.1709 18.5824L21.8658 23.8092C21.9047 23.9395 21.9021 24.0787 21.8584 24.2075C21.8148 24.3363 21.7322 24.4483 21.6222 24.5282C21.5121 24.6081 21.38 24.6518 21.244 24.6533C21.108 24.6549 20.9749 24.6142 20.8631 24.5369L16.426 21.3067C16.3157 21.2246 16.1819 21.1802 16.0444 21.1802C15.9069 21.1802 15.7731 21.2246 15.6628 21.3067L11.2258 24.5369C11.1139 24.6142 10.9808 24.6549 10.8448 24.6533C10.7089 24.6518 10.5767 24.6081 10.4667 24.5282C10.3566 24.4483 10.2741 24.3363 10.2304 24.2075C10.1868 24.0787 10.1842 23.9395 10.223 23.8092L11.9268 18.5824C11.9667 18.4512 11.9651 18.3108 11.9222 18.1806C11.8793 18.0503 11.7973 17.9365 11.6872 17.8547L7.25019 14.6334C7.13579 14.5542 7.04994 14.4402 7.00535 14.3084C6.96076 14.1766 6.9598 14.0339 7.00261 13.9015C7.04541 13.7691 7.12971 13.654 7.24303 13.5733C7.35634 13.4925 7.49265 13.4504 7.63177 13.4531H13.116C13.2543 13.4539 13.3892 13.4103 13.5009 13.3289C13.6127 13.2475 13.6955 13.1324 13.7372 13.0006L15.4321 7.78258C15.4851 7.66962 15.5691 7.57408 15.6744 7.50716C15.7797 7.44024 15.9019 7.40469 16.0267 7.40469C16.1514 7.40469 16.2736 7.44024 16.3789 7.50716C16.4842 7.57408 16.5683 7.66962 16.6212 7.78258V7.78258Z"
          stroke={color}
          strokeWidth="2.04104"
          strokeMiterlimit="10"
        />
      </Svg>
    </View>
  );
}
